/** @format */

import {useSave} from './use_save';

export const useSaveInput = (endpoint, field, debounceDelay = 500) => {
    const {save, isSaving, error} = useSave(endpoint, debounceDelay);

    const saveInput = value => {
        return save({[field]: value});
    };

    return {saveInput, isSaving, error};
};
